"use client";
import { jsxs as u, jsx as C } from "react/jsx-runtime";
import { useId as c } from "react";
import { Card as b } from "../Card/Card.js";
import { Collapse as x } from "../Collapse/Collapse.js";
import { CollapsibleCardHeader as _ } from "./Header/CollapsibleCardHeader.js";
import { CollapsibleCardBody as n } from "./Body/CollapsibleCardBody.js";
import { CollapsibleCardFooter as E } from "./Footer/CollapsibleCardFooter.js";
import { CollapsibleCardTitle as I } from "./Title/CollapsibleCardTitle.js";
import { CollapsibleCardSubtitle as h } from "./Subtitle/CollapsibleCardSubtitle.js";
import { useUncontrolled as j } from "../../utils/use-uncontrolled.js";
const r = ({
  children: t,
  isExpanded: e,
  isInitiallyExpanded: m,
  onExpandChange: d,
  renderHeader: s,
  renderNonCollapsibleContent: l,
  withTransition: p,
  ...f
}) => {
  const i = c(), [o, a] = j({
    defaultValue: m,
    value: e,
    finalValue: !1,
    onChange: d
  });
  return /* @__PURE__ */ u(b, { ...f, children: [
    s({
      _isExpanded: o,
      _buttonAriaControls: i,
      _buttonOnClick: () => a(!o),
      _onClick: () => {
        a(!o);
      }
    }),
    /* @__PURE__ */ C(
      x,
      {
        id: i,
        isExpanded: o,
        withTransition: p,
        children: t
      }
    ),
    l == null ? void 0 : l({ _isExpanded: o })
  ] });
};
r.Header = _;
r.Body = n;
r.Footer = E;
r.Title = I;
r.Subtitle = h;
export {
  r as CollapsibleCard
};
